import UserInitials, { UnassignedIcon } from "components/comments/UserInitials";
import { toast } from "components/ui/toast/Toast";
import { useCompany } from "lib/hooks/api/company/useCompany";
import { useUpdateBids } from "../../lib/hooks/api/bid/bids/useUpdateBids";
import { pluralise } from "../../lib/utils";
import { DropdownMenu, DropdownMenuItem, DropdownMenuTrigger } from "../ui/dropdown_menu";

export function BidAssigneeBulkUpdateButton({ selectedBidIds }: { selectedBidIds: string[] }) {
  const { data: company, isLoading: isLoadingCompany } = useCompany();

  const { mutate: updateBids } = useUpdateBids({
    onSuccess: (data) => {
      const assignee = data.updateBids[0]?.assignedTo;
      const name = assignee ? `${assignee.firstName} ${assignee.lastName}` : "Unassigned";

      toast.success(`${pluralise(data.updateBids.length, "bid")} changed to '${name}'`);
    },
    onError: () => {
      toast.error("Failed to update bid assignee");
    },
  });

  return (
    <DropdownMenu
      width="fit-content"
      maxHeight={300}
      trigger={
        <DropdownMenuTrigger buttonType="primary" icon="user01" loading={isLoadingCompany}>
          Assignee
        </DropdownMenuTrigger>
      }
    >
      <DropdownMenuItem
        key="Unassigned"
        value="Unassigned"
        onClick={() => {
          updateBids({
            updateBidsRequest: { ids: selectedBidIds, updateData: { assignedToId: null } },
          });
        }}
      >
        <UnassignedIcon showTooltip={false} type="extra-small" /> Unassigned
      </DropdownMenuItem>
      {company?.users.map((user) => {
        const fullName = `${user.firstName} ${user.lastName}`;

        return (
          <DropdownMenuItem
            key={user.guid}
            value={user.guid}
            onClick={() => {
              updateBids({
                updateBidsRequest: {
                  ids: selectedBidIds,
                  updateData: { assignedToId: user.guid },
                },
              });
            }}
          >
            <UserInitials
              firstName={user.firstName}
              lastName={user.lastName}
              showTooltip={false}
              type="extra-small"
            />
            {fullName}
          </DropdownMenuItem>
        );
      })}
    </DropdownMenu>
  );
}
